export function hasFileId(value: unknown): boolean {
  if (Array.isArray(value)) return value.some(hasFileId);
  if (typeof value !== "object" || value === null) return false;
  const fileId = Reflect.get(value, "fileId");
  return typeof fileId === "string" && fileId !== "";
}
